import { EditScheduledEmail } from '@/connection/emails/edit-scheduled-email';
import { serializeError, getPayloadMessage, SerializedError } from '@/store/utils/serialize-error';
import { IScheduledEmail } from '@/types/email.types';
import toastTrigger from '@ui/toast/toast-trigger';
import { ProjectStateReducerCreator } from '../types';
import { EToastTypes } from '@ui/toast/toast.types';

const editScheduledEmailReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ email }: { email: IScheduledEmail }, { rejectWithValue }) => {
      try {
        const result = await EditScheduledEmail(email);
        if ('error' in result) {
          console.error('editScheduledEmail error', result.error);
          return rejectWithValue(serializeError(result.error));
        }
        return result;
      } catch (error) {
        console.error('Error editing scheduled email:', error);
        return rejectWithValue('Error editing scheduled email');
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload && state.scheduledEmails) {
          const updatedEmails = state.scheduledEmails.map((email) => {
            if (email.uuid === action.payload.uuid) {
              return action.payload;
            }
            return email;
          });
          state.scheduledEmails = updatedEmails;
        }
        state.loadingScheduledEmails = false;
      },
      pending: (state) => {
        state.loadingScheduledEmails = true;
      },
      rejected: (state, action) => {
        console.error('Error editing scheduled email:', action.error);
        state.loadingScheduledEmails = false;
        const errMsg =
          getPayloadMessage(action.payload as SerializedError | string | undefined) || action.error?.message;

        toastTrigger('There was an error editing the scheduled email', {
          type: EToastTypes.error,
          autoClose: 5000,
          description: errMsg,
        });
      },
    }
  );
};

export default editScheduledEmailReducer;
